'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _localeProvider = require('antd/lib/locale-provider');

var _localeProvider2 = _interopRequireDefault(_localeProvider);

exports.default = localeWrapper;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _zh_CN = require('antd/lib/locale-provider/zh_CN');

var _zh_CN2 = _interopRequireDefault(_zh_CN);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function localeWrapper(lang, child) {
    return _react2.default.createElement(
        _localeProvider2.default,
        { locale: _zh_CN2.default },
        child
    );
}
module.exports = exports['default'];